import { Component } from '@angular/core';

@Component({
  selector: 'vias-auth-layout',
  styleUrls: ['./auth-layout.component.scss'],
  templateUrl: './auth-layout.component.html'
})
export class AuthLayoutComponent {}
